// extracted by mini-css-extract-plugin
export default {"input_box":"FileInput_input_box__sPdNs","icon":"FileInput_icon__Bct8m","file_box":"FileInput_file_box__JYvdd","half":"FileInput_half__v0nBT"};